<template>
  <div>
    <basic-container>
<!--      <avue-tabs :option="option"-->
<!--                 v-model="form"-->
<!--                 @change="handleChange"-->
<!--                 @submit="handleSubmit">-->
<!--      </avue-tabs>-->
      <el-tabs  v-model="activeName" style="margin-left: 10px" >
      <el-tab-pane label="个人信息" name="info" @tab-click="handleClick" >

        <el-form :model="infoForm" ref="infoForm" :rules="rules" >
          <el-form-item label="头像" prop="avatar_url" :label-width="formLabelWidth">
            <el-upload :headers="headers" class="avatar-uploader" action="/api/v4ward/oss/customEndpoint/put-file" :before-upload="beforeupload"  :show-file-list="false" :on-success="handleUpSuccess">
              <img v-if="infoForm.avatar" :src="infoForm.avatar" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon " style="width:80px;height:80px;"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="姓名" prop="name" :label-width="formLabelWidth">
            <el-col :span="8"> <el-input v-model="infoForm.name"  ></el-input></el-col>
          </el-form-item>
          <el-form-item label="用户名" prop="realName" :label-width="formLabelWidth">
            <el-col :span="8"> <el-input v-model="infoForm.realName"  ></el-input></el-col>
          </el-form-item>
          <el-form-item label="电话" prop="phone" :label-width="formLabelWidth">
            <el-col :span="8">  <el-input v-model="infoForm.phone" placeholder="请输入电话"></el-input></el-col>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" :label-width="formLabelWidth">
            <el-col :span="8">  <el-input v-model="infoForm.email" placeholder="请输入邮箱"></el-input></el-col>
          </el-form-item>

        </el-form>
        <div class="grid-content bg-purple" align="center">
          <el-button type="primary" @click="submitInfo('infoForm')" >提交</el-button>
          <el-button
            class="danger"
            type="text"
            size="medium"
            icon="el-icon-delete"
            @click="handleInfoClear"
          >清空</el-button
          >
        </div>
      </el-tab-pane >

      <el-tab-pane label="修改密码" name="password">
        <el-form :model="passwordForm" :rules="rules" ref="passwordForm" :disabled="viewFlag">
          <el-form-item label="原密码" prop="oldPassword" :label-width="formLabelWidth">
            <el-col :span="8">  <el-input v-model="passwordForm.oldPassword" placeholder="请输入原密码" type="password"></el-input></el-col>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
            <el-col :span="8"><el-input v-model="passwordForm.newPassword" placeholder="请输入新密码" id="newkey" type="password"></el-input></el-col>
          </el-form-item>
          <el-form-item label="确认密码" prop="newPassword1" :label-width="formLabelWidth">
            <el-col :span="8">  <el-input v-model="passwordForm.newPassword1" placeholder="请再次输入新密码" id='newkey1' type="password"></el-input></el-col>
          </el-form-item>
        </el-form>
        <div class="grid-content bg-purple" align="center">
          <el-button type="primary" @click="submitPassword('passwordForm')">提交</el-button>
          <el-button
            class="danger"
            type="text"
            size="medium"
            icon="el-icon-delete"
            @click="handlePasswordClear"
          >清空</el-button
          >
        </div>

      </el-tab-pane>
      </el-tabs>
    </basic-container>
  </div>
</template>

<script>

  import { Base64 } from 'js-base64';
  import settings from '@/config/vd-settings';
  import { getToken } from '@/util/auth';
  //import option from "@/const/user/info";
  // import {getUserInfo, updateInfo, updatePassword} from "@/api/system/user";
  import {getUserInfo, updateInfo, updatePassword} from "@/api/v4ward/v4system/user";
  import md5 from 'js-md5';

  /*****检验两次密码是否一致***/


  export default {
    data() {

      var validatePass = (rule, value, callback) => {
        if (value === undefined || value==="") {
          callback(new Error("请输入密码"));
        }else if(!(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·])[a-zA-Z0-9`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·]{8,16}$/).test(value)){
          callback(new Error("8位以上，含大小写字母、数字和字符"));
        }else {
          if (this.infoForm.newPassword1 !== "") {
            this.$refs.infoForm.validateField("newPassword1");
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === undefined || value==="") {
          callback(new Error("请再次输入密码"));
        } else if(!(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·])[a-zA-Z0-9`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·]{8,16}$/).test(value)){
          callback(new Error("8位以上，含大小写字母、数字和字符"));
        } else if (value !== this.passwordForm.newPassword) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };

      return {
        formLabelWidth: "150px",
        type: "info",
        activeName: "info",
        infoForm: {
          avatar: '',
        },
        viewFlag:'',
        passwordForm: {},
        /***校验***/
        rules: {
          phone: [
            {
              required: false,
              message: "请输入电话号码"
            },

          ],
          name: [
            {
              required: true,
              message: "请输入姓名"
            },

          ],
          realName: [
            {
              required: true,
              message: "请输入用户名"
            },

          ],
          email: [
            {
              required: false,
              message: "请输入电子邮箱"
            },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/,
              message: "请输入有效的邮箱"
            }
          ],
          oldPassword: [
            {
              required: true,
              trigger: "blur",
              message: "请输入原始密码"
            }
          ],
          newPassword: [
            {
              required: true,
              validator: validatePass,
              trigger: "blur"
            }
          ],
          newPassword1: [
            {
              required: true,
              validator: validatePass2,
              trigger: "blur"
            }
          ]
        },
        //option: option,
        // infoOption:{
        //       column: [{
        //         label: '头像',
        //         type: 'upload',
        //         listType: 'picture-img',
        //         propsHttp: {
        //           res: 'data',
        //           url: 'link',
        //         },
        //         canvasOption: {
        //           text: ' ',
        //           ratio: 0.1
        //         },
        //         action: '/api/blade-resource/oss/endpoint/put-file',
        //         tip: '只能上传jpg/png用户头像，且不超过500kb',
        //         span: 12,
        //         row: true,
        //         prop: 'avatar'
        //       }, {
        //         label: '姓名',
        //         span: 12,
        //         row: true,
        //         prop: 'name'
        //       }, {
        //         label: '用户名',
        //         span: 12,
        //         row: true,
        //         prop: 'realName'
        //       }, {
        //         label: '手机号',
        //         span: 12,
        //         row: true,
        //         prop: 'phone'
        //       }, {
        //         label: '邮箱',
        //         prop: 'email',
        //         span: 12,
        //         row: true,
        //       }]
        // },
        // passwordOption:{
        //   column: [{
        //     label: '原密码',
        //     span: 12,
        //     row: true,
        //     type: 'password',
        //     prop: 'oldPassword'
        //   }, {
        //     label: '新密码',
        //     span: 12,
        //     row: true,
        //     type: 'password',
        //     prop: 'newPassword'
        //   }, {
        //     label: '确认密码',
        //     span: 12,
        //     row: true,
        //     type: 'password',
        //     prop: 'newPassword1'
        //   }]
        // },
        form: {},
        headers:{}
      };
    },
    created() {
      this.headers['Authorization'] = `Basic ${Base64.encode(
        `${settings.clientId}:${settings.clientSecret}`
      )}`;

        // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        this.headers['Blade-Auth'] = 'bearer ' + getToken();
      this.handleWitch();
      this.viewFlag=false;
    },
    methods: {

      handlePasswordClear(){
        if (
          this.passwordForm ||
          this.passwordForm.column ||
          this.passwordForm.column.length > 0
        ) {
          this.$confirm("确定要清空吗？", "警告", {
            type: "warning",
          })
            .then(() => {
              this.clearPassword();
              this.viewFlag=false;
            })
            .catch(() => {});
        } else this.$message.error("没有需要清空的内容");

      },

      handleInfoClear(){
        console.log(this.infoForm)
        if (
          this.infoForm ||
          this.infoForm.column ||
          this.infoForm.column.length > 0
        ) {
          this.$confirm("确定要清空吗？", "警告", {
            type: "warning",
          })
            .then(() => {
              this.clearInfo();
            })
            .catch(() => {});
        } else this.$message.error("没有需要清空的内容");
      },
      //清空密码信息
      clearPassword(){
        this.passwordForm.oldPassword='';
        this.passwordForm.newPassword='';
        this.passwordForm.newPassword1='';
      },
      //清空个人信息
      clearInfo(){
        this.infoForm.name='';
        this.infoForm.realName='';
        this.infoForm.phone='';
        this.infoForm.email='';
      },
      //上传之前
      beforeupload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      //图片上传上传成功
      handleUpSuccess(response) {
        console.log(response)
        this.infoForm.avatar = response.data.link;
      },

      //tab切换
      handleClick(tab, event) {
        console.log(tab, event);
      },

      submitInfo(done,loading){
        this.$refs.infoForm.validate((valid) => {
          if (valid) {
        updateInfo(this.infoForm).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "修改信息成功!"
            });
            done();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
            loading();
          }
        })
          }
        });
      },

      submitPassword(){
        this.$refs.passwordForm.validate((valid) => {
          if (valid) {
        updatePassword(md5(this.passwordForm.oldPassword), md5(this.passwordForm.newPassword), md5(this.passwordForm.newPassword1)).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "修改密码成功!"
            });
            this.viewFlag=true;
          } else {

            this.$message({
              type: "error",
              message: res.data.msg
            });


          }
        })
        this.clearPassword();
          }
        });
      },

      // handleSubmit(done,loading) {
      //   if (this.type === "info") {
      //     updateInfo(this.form).then(res => {
      //       if (res.data.success) {
      //         this.$message({
      //           type: "success",
      //           message: "修改信息成功!"
      //         });
      //         done();
      //       } else {
      //         this.$message({
      //           type: "error",
      //           message: res.data.msg
      //         });
      //         loading();
      //       }
      //     })
      //   } else {
      //     updatePassword(md5(this.form.oldPassword), md5(this.form.newPassword), md5(this.form.newPassword1)).then(res => {
      //       if (res.data.success) {
      //         this.$message({
      //           type: "success",
      //           message: "修改密码成功!"
      //         });
      //         done();
      //       } else {
      //         this.$message({
      //           type: "error",
      //           message: res.data.msg
      //         });
      //
      //         loading();
      //       }
      //     })
      //   }
      // },
      handleWitch() {
        //if (this.type === "info") {
          getUserInfo().then(res => {
            const user = res.data.data;
            this.infoForm = {
              id: user.id,
              avatar: user.avatar,
              name: user.name,
              realName: user.realName,
              phone: user.phone,
              email: user.email,
            }
          });
        //}
      },
      handleChange(item) {
        this.type = item.prop;
        this.handleWitch();
      }
    }
  };
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
